import { render } from "./Toggle.vue?vue&type=template&id=4135ea1c&scoped=true"
import script from "./Toggle.vue?vue&type=script&lang=js"
export * from "./Toggle.vue?vue&type=script&lang=js"

import "./Toggle.vue?vue&type=style&index=0&id=4135ea1c&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-4135ea1c"

export default script